import React, { useContext, Suspense } from 'react';

import pluralize from 'helpers/pluralize';

import { EntityContext } from 'context/entityContext';
import Layout from 'components/styled/Layout/Layout';
import Message from 'components/base/Message/Message';
import ShortFormVideoTrend from 'components/data-containers/ShortFormVideo/ShortFormVideoTrend';
import ShortFormVideoKPIs from 'components/data-containers/KPIs/ShortFormVideo/ShortFormVideoKPIs';
import ShortFormVideoTerritorySkeletonLoader from 'components/data-containers/ShortFormVideoTerritories/SkeletonLoader';
import PerformanceBreakdownLoader from 'components/data-containers/PerformanceBreakdown/SkeletonLoader';

const ShortFormVideoTerritories = React.lazy(
  () =>
    import(
      'components/data-containers/ShortFormVideoTerritories/ShortFormVideoTerritories'
    )
);

const PerformanceBreakdown = React.lazy(
  () =>
    import(
      'components/data-containers/ShortFormVideoTotalToDate/PerformanceBreakdown'
    )
);

const ShortFormVideo: React.FC = () => {
  const ctx = useContext(EntityContext);
  const { compareMode, entityType } = ctx;

  return (
    // Note: Do not remove the next <div>. It avoids flexbox to double margins between generic components.
    <div>
      <ShortFormVideoKPIs appName={'Short Form Videos'} {...ctx} />

      <ShortFormVideoTrend
        componentId="shortFormVideo-performance-trend"
        title={`Short Form Video Performance`}
      />

      {!compareMode && (
        <React.Suspense fallback={<ShortFormVideoTerritorySkeletonLoader />}>
          <ShortFormVideoTerritories appName={'Short Form Video'} />
        </React.Suspense>
      )}

      {compareMode && (
        <Layout.MaxWidth>
          <Message>
            Short Form Video Territories is not available in compare{' '}
            {pluralize(compareMode === 'country' ? compareMode : entityType)}{' '}
            mode. Exit compare mode to see Short Form Video Territories for this{' '}
            {entityType}.
          </Message>
        </Layout.MaxWidth>
      )}

      {!compareMode && (
        <Suspense
          fallback={
            <PerformanceBreakdownLoader
              barCount={2}
              title="Short Form Video Total To Date"
            />
          }
        >
          <PerformanceBreakdown />
        </Suspense>
      )}

      {compareMode && (
        <Layout.MaxWidth>
          <Message>
            Short Form Video Total to Date is not available in compare{' '}
            {pluralize(compareMode === 'country' ? compareMode : entityType)}{' '}
            mode. Exit compare mode to see Short Form Video Total to Date for
            this {entityType}.
          </Message>
        </Layout.MaxWidth>
      )}
    </div>
  );
};

export default ShortFormVideo;
